import styled from '@emotion/styled';

import { SUI_ICON_COLOR } from '@/shared/modules/wallet/colors';

export const IconRoot = styled('div', {
  shouldForwardProp: (prop) => prop !== '$size' && prop !== '$isSui',
})<{ $size: number; $isSui: boolean }>(({ theme, $size, $isSui }) => ({
  width: $size,
  height: $size,
  borderRadius: theme.radius.full,
  background: $isSui ? SUI_ICON_COLOR : theme.colors.background.overlay,
  border: $isSui ? 0 : `1px solid ${theme.colors.border.default}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  overflow: 'hidden',
}));

export const SuiGlyph = styled('img')({
  width: '75%',
  height: '75%',
  objectFit: 'contain',
  filter: 'brightness(0) invert(1)',
});

export const CoinArtwork = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});
